<div class="so-column-picker">
  <button
    #trigger
    type="button"
    class="so-column-picker-trigger"
    cdkOverlayOrigin
    #origin="cdkOverlayOrigin"
    aria-haspopup="menu"
    [attr.aria-expanded]="isOpen()"
    (click)="toggleOpen($event)">
    <span class="so-column-picker-label">{{ label() }}</span>
    @if (showCounter()) {
      <span class="so-column-picker-counter">{{ shownCount() }}/{{ totalCount() }}</span>
    }
  </button>

  <ng-template
    cdkConnectedOverlay
    [cdkConnectedOverlayOrigin]="origin"
    [cdkConnectedOverlayOpen]="isOpen()"
    [cdkConnectedOverlayPositions]="overlayPositions"
    [cdkConnectedOverlayScrollStrategy]="scrollStrategy"
    [cdkConnectedOverlayHasBackdrop]="true"
    [cdkConnectedOverlayBackdropClass]="'cdk-overlay-transparent-backdrop'"
    (backdropClick)="closePanel()"
    (detach)="closePanel()">
    <div class="so-column-picker-panel" role="menu" (keydown)="onPanelKeydown($event)">
      @for (column of columns(); track column.key) {
        <div class="so-column-picker-row">
          <so-checkbox-ui
            [label]="column.label"
            [checked]="isChecked(column)"
            [disabled]="isLocked(column)"
            (checkedChange)="onToggleColumn(column, $event)" />
          @if (isLocked(column)) {
            <svg class="so-column-picker-lock" viewBox="0 0 24 24" width="14" height="14" aria-hidden="true">
              <path fill="currentColor" d="M12 17a2 2 0 0 0 2-2 2 2 0 0 0-2-2 2 2 0 0 0-2 2 2 2 0 0 0 2 2m6-9a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V10a2 2 0 0 1 2-2h1V6a5 5 0 0 1 10 0v2h1M12 3a3 3 0 0 0-3 3v2h6V6a3 3 0 0 0-3-3Z" />
            </svg>
          }
        </div>
      }
      <button type="button" class="so-column-picker-reset" (click)="onReset()">
        {{ resetLabel() }}
      </button>
    </div>
  </ng-template>
</div>
